import styled, { css } from 'styled-components';

export const StyledColumn = styled.th`

  ${({ isSortable }) => isSortable && css`
    cursor: pointer;
  `}
`;
